const state = {
  visitedViews: [],
  cachedViews: []
};

export default {
  state
};
